
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/van/volkswagen-caddy",
      function () {
        return require("private-next-pages/wheels/van/volkswagen-caddy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/van/volkswagen-caddy"])
      });
    }
  